import Map from 'ol/Map.js';
import View from 'ol/View.js';
import {defaults as defaultControls, Attribution} from 'ol/control.js';
import TileLayer from 'ol/layer/Tile.js';
import XYZ from 'ol/source/XYZ.js';

// default zoom, center and rotation
var zoom = 2;
var center = [0, 0];
var rotation = 0;

if (window.location.hash !== '') {
    // try to restore center, zoom-level and rotation from the URL
    var hash = window.location.hash.replace('#map=', '');
    var parts = hash.split('/');
    if (parts.length === 4) {
        zoom = parseInt(parts[0], 10);
        center = [
            parseFloat(parts[1]),
            parseFloat(parts[2])
        ];
        rotation = parseFloat(parts[3]);
    }
}

var map = new Map({
    layers: [new TileLayer({
    source: new XYZ({
        url: thetileset+'/{z}/{x}/{y}.png',
        attributions: 'Satellite imagery contains modified Copernicus Sentinel data 2019',
    })
})],
    target: 'map',
    view: new View({
        center: center,
        zoom: zoom,
        rotation: rotation,
        //projection: 'EPSG:4326'
    })
});

var attribution = new Attribution({
    collapsible: true,
    collapsed: true
});

var shouldUpdate = true;
var view = map.getView();
var updatePermalink = function() {
    if (!shouldUpdate) {
        // do not update the URL when the view was changed in the 'popstate' handler
        shouldUpdate = true;
        return;
    }

    var center = view.getCenter();
    var hash = '#map=' +
        view.getZoom() + '/' +
        Math.round(center[0] * 100) / 100 + '/' +
        Math.round(center[1] * 100) / 100 + '/' +
        view.getRotation();
    var state = {
        zoom: view.getZoom(),
        center: view.getCenter(),
        rotation: view.getRotation()
    };
    window.history.pushState(state, 'map', hash);
};

map.on('moveend', updatePermalink);

// restore the view state when navigating through the history, see
// https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
window.addEventListener('popstate', function(event) {
    if (event.state === null) {
        return;
    }
    map.getView().setCenter(event.state.center);
    map.getView().setZoom(event.state.zoom);
    map.getView().setRotation(event.state.rotation);
    shouldUpdate = false;
});

var overlayLayer = new TileLayer({
    source: new XYZ({
        url: 'https://{a-d}.tiles.mapbox.com/v4/openstreetmap.map-inh76ba2/{z}/{x}/{y}.png?access_token=pk.eyJ1IjoiY2FtZXJvbmQiLCJhIjoiY2l2cWxnNXk2MDNpZjJ0bjJmcmZ6Y3hodSJ9.qOVO_YXJ86jlhlazfG843A',
        attributions: "Location Overlay © <a href='https://www.mapbox.com/about/maps/'>Mapbox</a> © <a href='http://www.openstreetmap.org/copyright'>OpenStreetMap</a> <a href='https://www.mapbox.com/map-feedback/' target='_blank'>Improve this map</a>"
    })
})

map.addLayer(overlayLayer);

var overlayToggle = document.getElementById("overlaytoggle")
overlaytoggle.addEventListener('click', function() {
    if (overlayLayer.getVisible()) {
        overlayToggle.textContent = "Show Location Overlay"
        overlayLayer.setVisible(false);
    } else {
        overlayToggle.textContent = "Hide Location Overlay"
        overlayLayer.setVisible(true);
    }
})
